<template>
  <section>
    <header-portal></header-portal>
    <template>
      <v-layout row wrap justify-center v-show="!this.tokeVarificado">
        <v-progress-circular
          :size="100"
          :width="7"
          color="secondary"
          indeterminate
        ></v-progress-circular>
      </v-layout>
      <v-dialog v-model="dialogVisible" scrollable persistent max-width="750">
        <v-card>
          <v-card-title><h4> <v-icon large color="info">mail</v-icon> Contraseña cambiada correctamente.</h4></v-card-title>
          <v-card-text>
            <h3>Se cambio la contraseña de la cuenta <strong>{{this.form.cuefundec}} </strong> que pertenece a <strong> {{this.respustaCambioPw.nombre}} </strong> </h3>
            <h3>por medio del correo <strong>{{this.respustaCambioPw.correo}}</strong></h3>
            <h3><b>Favor tomar nota de la cuenta y la contraseña</b></h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="dialogVisible = false, $router.push('/')"><v-icon>check</v-icon>&nbsp;Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card v-show="this.tokeVarificado">
        <v-card-text>
          <v-alert align='justify'
            :value="true"
            type="info"
            outline
          > Digite su contraseña, por seguridad debe ser mayor a 8 caracteres, contener letras y números (A-Z, 0 - 9) y al menos un caracter especial.
          Por ejemplo: "@ # % &". Resguarde su contraseña para evitar fraudes y no ser sancionado según el D.S. N° 1233
          </v-alert>
          <v-form v-model='valid' ref='form' lazy-validation>   
            <v-layout row wrap justify-center>
              <v-flex md4 offset-md3>
                <p>Cuenta de Usuario</p>
                <h2>{{this.form.cuefundec}}</h2>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 offset-md3>
                <v-text-field
                  style="font-size: 20px;"
                  class="text-normal"
                  v-model="form.cuefundec_contrasenia"
                  label='Contraseña  '
                  :rules='passRule'
                  required
                  type='password'
                  prepend-icon="security"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 offset-md3>
                <v-text-field
                  style="font-size: 20px;"
                  v-model="form.cuefundec_contrasenia2"
                  label='Repetir Contraseña  '
                  :rules='passRule'
                  class="text-normal"
                  required
                  type='password'
                  prepend-icon="security"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>    
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn
            color="success"
            @click="actualizaContrasenia(), loader = 'loadingButton'"
            :loading="loadingButton"
            :disabled="loadingButton"
            >
            <v-icon>save</v-icon>&nbsp;Guardar
            <template v-slot:loader>
                     <span>procesando..</span>
                     </template>
          </v-btn>
           <v-btn color="error" @click="$router.push('/')"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </section>
</template>
<script>
import HeaderPortal from '@/components/djbrd/headerPortal.vue';
import Cuentas from '../mixins/cuentas.js';

export default {
  mixins: [Cuentas],
  components: {
    HeaderPortal
  },
  created () {
    this.clave = this.$route.query.clave;
    this.$service
    .get(`control_tarjeta/reset?clave=${this.clave}`)
    .then(response => {
      if (response) {
        this.$message['success']('La verificación fue correcta, por favor cambie su contraseña');
        this.form.cuefundec = response.cuenta;
        this.tokeVarificado = true;
      }
    }).catch(err => {
      console.log(err);
      this.$message['warning']('La verificación no fue correcta.');
      this.tokeVarificado = false;
      this.$route.push('/');
    });
  },
  data: () => ({
    modalvisible: false,
    clave: '',
    tokeVarificado: false,
    valid: true,
    dialogVisible: false,
    form: {
      cuefundec: '',
      cuefundec_contrasenia: '',
      cuefundec_contrasenia2: ''
    },
    respustaCambioPw: {
      celular: '',
      correo: '',
      cuefundec_estado_descripcion: '',
      nombre: ''
    },
    loader: null,
    loadingButton: false,
    passRule: [v => /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W_]){1,})(?!.*\s).{8,}$/.test(v) || 'Debe tener al menos 8 caracteres, una letra mayúscula (A-Z), minúscula (a-z), un número (0-9) y un caracter especial, por ejemplo ( @ # $ % ^ & * ç )']
  }),
  methods: {
    clearLoaders () {
      this.loader = null;
      this.loadingButton = false;
      this.buttonCancel = false;
    },
    actualizaContrasenia () {
      if (this.$refs.form.validate()) {
        this.buttonCancel = !this.buttonCancel;
        this.loadingButton = true;
        if (this.form.cuefundec_contrasenia === this.form.cuefundec_contrasenia2) {
          this.$service
            .post(`control_tarjeta/reset?clave=${this.clave}`, this.form)
            .then(response => {
              this.respustaCambioPw.celular = response.celular;
              this.respustaCambioPw.correo = response.correo;
              this.respustaCambioPw.cuefundec_estado_descripcion = response.cuefundec_estado_descripcion;
              this.respustaCambioPw.nombre = response.nombre;
              this.dialogVisible = true;
              this.clearLoaders();
            })
            .catch(err => {
              console.log(err);
              this.clearLoaders();
            });
        } else {
          this.$message['warning']('Las contraseñas no coinciden, favor validar');
          this.clearLoaders();
        }
      }
    }
  }
};
</script>
<style lang='scss'>
@import '../../admin/auth/login.scss';
</style>



// WEBPACK FOOTER //
// src/components/portal/login/CambiarContrasenia.vue